export const showPreviewDocumentFromStream = async (blob: Blob) => {
	if (!blob) {
		return;
	}
	const fileURL = URL.createObjectURL(blob);
	window.open(fileURL);
};

export function fileToBlob(file: File): Promise<Blob> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(new Blob([reader.result as string]));
		reader.onerror = reject;
		reader.readAsArrayBuffer(file);
	});
}
